import React from "react";
import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const WarningPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#fffaf3] rounded-2xl border border-[#dfc4a1] shadow-2xl p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-[#fff0d8] flex items-center justify-center">
            <AlertTriangle size={48} className="text-[#d9932b]" />
          </div>
        </div>

        <h1 className="text-2xl md:text-3xl font-bold text-[#34251f] mb-4">
          Developer Tools Detected
        </h1>

        <p className="text-[#7d6a5e] mb-6">
          Please close Developer Tools to continue using the application. This
          helps protect our content and ensures the best experience.
        </p>

        <div className="bg-white rounded-lg border border-[#ead9c4] p-4 mb-6">
          <p className="text-sm text-[#7a5b49]">
            Press F12 or right-click → Inspect to close Developer Tools
          </p>
        </div>

        <button
          onClick={() => navigate("/")}
          className="px-6 py-2 bg-gradient-to-r from-[#f3be63] to-[#d8922d] text-[#3e271d] font-semibold rounded-lg hover:scale-105 transition-transform"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default WarningPage;
